import { Input, Modal, PrimaryButton, PrimaryCardButton } from '@cb/apricot-react';
import { LinearProgress } from '@mui/material';
import { ChangeEventHandler, FC, useEffect, useState } from 'react';

import { useToasts } from 'src/hooks';
import { getValidatedSchoolName } from '../../../utils';
import { useAuth } from 'src/contexts';
import { FieldRow } from 'src/generic/component';
import { APP_URLS } from 'src/constants';
import { useNavigate } from 'react-router-dom';
import { createDIForm } from 'src/di/apis/createDiForm';

interface NewSchoolModalProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  onComplete: VoidFunction;
}

const NewScoreSendModal: FC<NewSchoolModalProps> = ({ isOpen, onClose, onComplete }) => {

  const navigate = useNavigate();

  const [schoolName, setSchoolName] = useState('');

  const { errorMessage, render: renderToasts, toastErrorMessage } = useToasts();

  const { userName, userEmail } = useAuth();

  const [loading, setLoading] = useState('');

  const handleChangeSchoolName: ChangeEventHandler<HTMLInputElement> = (event) => {
    setSchoolName(event.target.value);
  };

  useEffect(() => {
    setSchoolName('');
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!schoolName ) {
      toastErrorMessage('Please fill out the Institution Name.');
    } else {
      toastErrorMessage(null);
      setLoading('Creating');

      const validatedSchoolName = getValidatedSchoolName(schoolName);

      try {
        const created = await createDIForm({
          schoolName: validatedSchoolName,
          recordCategoryType: 'di',
          creator: userName,
          creatorEmail: userEmail
        });
         navigate(APP_URLS.DIFORM, { state: { summary: created } });
      
      } catch (error: any) {
        toastErrorMessage(error.message);
      }
      setLoading('');
    }
  };

  useEffect(() => {
    toastErrorMessage(null);
  }, [isOpen, toastErrorMessage]);

  return (
    // @ts-ignore
    <Modal
      title="College Board Score Send Codes"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit}>
          Submit
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {loading && <LinearProgress />}

      {renderToasts()}

      <div className="display-flex flex-column cb-padding-top-8">
        <div>
             College Board Score Send Codes are used to identify organizations designated by students to receive College Board assessment scores, to support post-secondary education opportunities.
          <br/>
        </div>
        <FieldRow>
          <Input
            floating={false}
            label="Institution Name"
            required
            placeholder="Institution Name"
            onChange={handleChangeSchoolName}
            value={schoolName}
            validation={errorMessage ? 'error' : undefined}
            validationMsg={errorMessage ?? undefined}
          />
        </FieldRow>
      </div>
    </Modal>
  );
};

export default NewScoreSendModal;
